import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/ironwood-logo.svg'


const _hoisted_1 = { class: "masthead" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container px-4 px-lg-5 d-flex h-100 align-items-center justify-content-center\"><div class=\"d-flex justify-content-center\"><div class=\"text-center\"><svg class=\"mx-auto\"><image style=\"filter:invert(99%) sepia(1%) saturate(991%) hue-rotate(299deg)\n                  brightness(112%) contrast(100%);height:9em;\" xlink:href=\"" + _imports_0 + "\"></image></svg><h1 class=\"mx-auto my-0\">ironwood whistles</h1></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, _hoisted_3))
}